/** Machine à états de l'application. Les transitions invalides sont refusées et loguées. */

export type AppStateName =
  | 'landing'
  | 'requesting-camera'
  | 'loading'
  | 'searching'
  | 'tracking'
  | 'recording'
  | 'preview'
  | 'error';

const TRANSITIONS: Record<AppStateName, readonly AppStateName[]> = {
  landing: ['requesting-camera', 'error'],
  'requesting-camera': ['loading', 'landing', 'error'],
  loading: ['searching', 'error'],
  searching: ['tracking', 'landing', 'error'],
  tracking: ['searching', 'recording', 'landing', 'error'],
  recording: ['preview', 'tracking', 'searching', 'error'],
  preview: ['searching', 'tracking', 'landing', 'error'],
  error: ['landing', 'requesting-camera'],
};

export type StateListener = (next: AppStateName, prev: AppStateName) => void;

export class AppState {
  private current: AppStateName = 'landing';
  private readonly listeners = new Set<StateListener>();

  get state(): AppStateName {
    return this.current;
  }

  canTransition(to: AppStateName): boolean {
    return TRANSITIONS[this.current].includes(to);
  }

  /** Retourne false (sans jeter) si la transition est interdite. */
  transition(to: AppStateName): boolean {
    if (!this.canTransition(to)) {
      console.warn(`[state] Transition refusée : ${this.current} → ${to}`);
      return false;
    }
    const prev = this.current;
    this.current = to;
    this.listeners.forEach((l) => l(to, prev));
    return true;
  }

  onChange(listener: StateListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
